import React, { type FC, useState } from 'react';
import { Share } from '@is24at/react-ui-core/Icons';
import { ShareModal } from './ShareModal';
import styles from './Share.scss';

type Props = {
  companyName: string;
};

export const ShareButton: FC<Props> = ({ companyName }) => {
  const [showShareOverlay, setShowShareOverlay] = useState(false);
  const handleClose = () => {
    setShowShareOverlay(false);
  };

  return (
    <>
      {showShareOverlay && (
        <ShareModal companyName={companyName} onClose={handleClose} />
      )}
      <button
        aria-label="share"
        type="button"
        className={styles.button}
        onClick={() => setShowShareOverlay(true)}
      >
        <Share size={24} />
      </button>
    </>
  );
};
